import { Button } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import "./CodeBlock.scss";
import { useTranslation } from "react-i18next";

interface CodeBlockProps {
  code: string;
}

const CodeBlock = ({ code }: CodeBlockProps) => {
    const {t} = useTranslation();
  const copyCode = () => {
    navigator.clipboard.writeText(code);
  };

  return (
    <div className="code-block-container">
      <div className="code-block-header">
        <Button
          size="small"
          icon={<CopyOutlined />}
          onClick={copyCode}
        >
          Copiar código
        </Button>
      </div>

      <pre className="code-block">
        <code>{code}</code>
      </pre>
    </div>
  );
};

export default CodeBlock;
